<template>
    <b-form-group label-for="phone">
        <template slot="label">
            {{ $t("pages.forms.common.phone") }}
            <span v-if="required" class="font-weight-bolder text-danger">
                *
            </span>
        </template>
        <validation-provider
            :rules="{ required, phone: { country: currentCountry } }"
            v-slot="{ dirty, validated, valid, errors }"
        >
            <b-input-group v-show="!isReviewing">
                <PhoneNumber
                    id="phone"
                    v-model="phone"
                    default-country-code="ES"
                    disable-leading-trailing-space
                    @update="onUpdate"
                    :translations="translations"
                    :preferred-countries="countries"
                    :valid-color="greenColor"
                    :error="dirty || validated ? !valid : false"
                    size="lg"
                    style="width:100%;"
                />
                <b-form-invalid-feedback
                    :state="dirty || validated ? valid : null"
                    >{{ errors[0] }}</b-form-invalid-feedback
                >
            </b-input-group>
        </validation-provider>
        <b-form-input
            type="text"
            :value="phoneValue"
            :readonly="true"
            :plaintext="true"
            v-show="isReviewing"
        />
    </b-form-group>
</template>

<script>
import FormInputHelpers from "../../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";
import PhoneNumber from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider, PhoneNumber },
    data() {
        return {
            phone: this.value.phone,
            countries: ["ES", "NO", "SE", "DK", "FI", "CO", "CN"],
            greenColor: "#09C179",
            currentCountry: "ES"
        };
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    phone: {}
                };
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onUpdate(payload) {
            this.currentCountry = payload.countryCode;
            this.$emit("input", { phone: payload.formattedNumber });
        }
    },
    computed: {
        isReviewing() {
            return this.reviewing;
        },
        phoneValue() {
            return this.value.phone;
        },
        translations() {
            return {
                countrySelectorLabel: this.$t(
                    "phoneTranslations.countrySelectorLabel"
                ),
                countrySelectorError: this.$t(
                    "phoneTranslations.countrySelectorError"
                ),
                phoneNumberLabel: this.$t("phoneTranslations.phoneNumberLabel"),
                example: this.$t("phoneTranslations.example")
            };
        }
    }
};
</script>

<style scoped />
